/**
 * 获取 API 配置
 * 优先读取外部配置文件 (public/config.js 中的 window.__APP_CONFIG__)
 * 没有则使用环境变量作为默认值
 */
export function getApiConfig() {
  const externalConfig = window.__APP_CONFIG__ || {}

  const config = {
    baseUrl: externalConfig.baseUrl || import.meta.env.VITE_API_BASE_URL || '/api',
    timeout: externalConfig.timeout || 30000,
    enableMock: import.meta.env.VITE_ENABLE_MOCK === 'true',
    loginUrl:
      externalConfig.loginUrl || import.meta.env.VITE_LOGIN_URL || '/oauth2/authorization/topiam'
  }

  return config
}
